<div class="content-dash">
  <h1>{{ 'changePass.title' | translate }}</h1>
  <form [formGroup]="form" class="change_pass">
    <div class="form-group">
      <label for="currentPassword">{{ 'changePass.currentPassword.label' | translate }}</label>
      <input autocomplete="actual_password" [formControl]="form.controls['actual_password']" type="password" id="currentPassword" name="currentPassword" placeholder="{{ 'changePass.currentPassword.placeholder' | translate }}" required>
      @if (form.controls['actual_password'].hasError('required') && form.controls['actual_password'].touched) {
        <small
        class="form-error-msg"> {{ 'changePass.currentPassword.requiredError' | translate }} </small>
      }
    </div>

    <div class="form-group">
      <label for="newPassword">{{ 'changePass.newPassword.label' | translate }}</label>
      <input autocomplete="new_password" [formControl]="form.controls['new_password']"  type="password" id="newPassword" name="newPassword" placeholder="{{ 'changePass.newPassword.placeholder' | translate }}"  required>
      @if (form.controls['new_password'].hasError('required') && form.controls['new_password'].touched) {
        <small
        class="form-error-msg"> {{ 'changePass.newPassword.requiredError' | translate }} </small>
      }
      @if (form.controls['new_password'].hasError('minlength') && form.controls['new_password'].touched ) {
        <small class="form-error-msg">{{ 'changePass.newPassword.minLengthError' | translate }}</small>
      }
    </div>

    <div class="form-group">
      <label for="confirmPassword">{{ 'changePass.confirmPassword.label' | translate }}</label>
      <input autocomplete="newPasswordConfirm" [formControl]="form.controls['newPasswordConfirm']"  type="password" id="confirmPassword" name="confirmPassword"  placeholder="{{ 'changePass.confirmPassword.placeholder' | translate }}" required>
      @if (form.controls['newPasswordConfirm'].hasError('required') && form.controls['newPasswordConfirm'].touched) {
        <small
        class="form-error-msg"> {{ 'changePass.confirmPassword.requiredError' | translate }} </small>
      }

      @if (form.controls['newPasswordConfirm'].hasError('minlength') && form.controls['newPasswordConfirm'].touched ) {
        <small class="form-error-msg">{{ 'changePass.confirmPassword.minLengthError' | translate }}</small>
      }

    </div>

    <button>{{ 'changePass.submitButton' | translate }}</button>
  </form>
</div>

